import { ExpandedRichText } from "@swo/shared";
import { RichTextContent } from "contentful";

// copy-paste from storefront

function richTextToStringHelper(richTextContent: RichTextContent): string {
  const nestedValues = (richTextContent.content || []).map(richTextToStringHelper).join("");
  switch (richTextContent.nodeType) {
    case "text":
    case "paragraph":
    case "heading-1":
    case "heading-2":
    case "heading-3":
    case "heading-4":
    case "heading-5":
    case "heading-6": {
      return (richTextContent.value || "") + nestedValues;
    }
    default: {
      return nestedValues;
    }
  }
}

export function richTextToString(richText: ExpandedRichText): string {
  return richText.json.content.map(richTextToStringHelper).join("");
}
